import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineNotification } from '@gaiads/telia-react-component-library';

const BuyoutPriceNotAvailableYetNotification: FunctionComponent = () => {
  const { t } = useTranslation('assets');

  return (
    <InlineNotification
      title={t('AssetCard.endOfLeaseNotifications.waitingForBuyoutPriceTitle')}
      messageText={t('AssetCard.endOfLeaseNotifications.waitingForBuyoutPriceMessage')}
      variant={'information'}
      hideIcon={false}
      color={'gray500'}
    ></InlineNotification>
  );
};

export default BuyoutPriceNotAvailableYetNotification;
